import Component from './Upload';

export default Component;
